var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticStyle:{"width":"100%","min-height":"800px"},attrs:{"srcdoc":_vm.report}})
}
var staticRenderFns = []

export { render, staticRenderFns }